import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Button from 'shared/components/Button';
import Box from 'shared/components/Box';
import SkipStep from 'shared/components/SkipStep';
import BackStep from 'shared/components/BackStep';

import {
  fetchSectors,
  patchUserSectors,
  nextStep,
  previousStep
} from 'shared/components/Signup/ducks';
import styles from './styles.module.scss';

class ChooseSectors extends Component {
  state = {
    chosenSectors: []
  };

  componentDidMount() {
    this.props.fetchSectors();
  }

  toggleSector = sector => {
    const newChoosenSectors = _.xor(this.state.chosenSectors, [sector.id]);
    this.setState({ chosenSectors: newChoosenSectors });
  };

  isSectorSelected = sector => {
    return _.indexOf(this.state.chosenSectors, sector.id) > -1;
  };

  render() {
    const { sectors, nextStep, previousStep } = this.props;

    const { chosenSectors } = this.state;

    return (
      <div className={styles.sectorsWrapper}>
        <BackStep onClickEvent={previousStep} />
        <div className={classnames('secondary-page-title', styles.pageTitle)}>
          Which sectors are you interested in?
        </div>
        <div className="page-title-label">Select all that apply.</div>
        <div className={styles.sectorsRow}>
          {sectors.map(sector => (
            <Box
              key={sector.name}
              image={sector.image}
              title={sector.name}
              onClickEvent={() => this.toggleSector(sector)}
              selected={this.isSectorSelected(sector)}
            />
          ))}
        </div>
        <div className={styles.nextStepAndSkipStepWrapper}>
          <Button
            className={styles.nextStepBtn}
            color="primary"
            onClick={() => {
              this.props.patchUserSectors({
                sectors: chosenSectors
              });
            }}
            disabled={_.isEmpty(chosenSectors)}>
            Next Step: Lifecycle
          </Button>
          <SkipStep onClickEvent={nextStep} className={styles.skipStepLink} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { sectors } = state.signup;
  return {
    sectors
  };
};

const mapDispatchToProps = {
  fetchSectors,
  patchUserSectors,
  nextStep,
  previousStep
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooseSectors);
